import React from 'react';
import { Spacer, Text, Link } from '@ontruck/orc';

const Pod = ({ changes: { stop_company_name, stop, cargo_manifest_url }, ...props }) => {
  return (
    <Spacer {...props}>
      <Text color="grey800" display="block">
        Stop {stop}: {stop_company_name}
      </Text>
      {!!cargo_manifest_url && (
        <Link
          link
          href={cargo_manifest_url}
          text="Download deleted PoD"
          weight="bold"
          skin="primary"
          noWrap
          target="_blank"
          data-testid="link"
        />
      )}
    </Spacer>
  );
};

export default Pod;
